import {BrickMailFragment} from "../../../../Queries";

export type FormDataMail = BrickMailFragment & {
  mailType?: MailEditorEnum
}

export type FormData = {
  mails: FormDataMail[];
  shopId: string;
  type: string;
  editor: string
}

export enum MailEditorEnum {
  Brick = 'BRICK',
  Html = 'HTML',
  Json = 'JSON'
}